import type { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import type { SlideShowBlock as SlideShowBlockValue } from "@reactivated";

import { FlagshipSlideshow } from "../../apps/retail-locator/FlagshipSlideshow";

/**
 * Native, value-based port of the FlagshipPage ``SlideShowBlock`` (#33473),
 * converted off the legacy ``slides_data`` JSON-string contract.
 *
 * The per-slide presentation data (image renditions + expanded richtext, in the
 * ``ISlideshowCell`` shape) is computed server-side and surfaced as
 * ``value.serialized_slides`` (see ``SlideShowBlock.get_data_for_client_render``);
 * it is fed UNCHANGED to the existing interactive ``FlagshipSlideshow`` component
 * (Flickity thumb-nav carousel, hydrated via the shared ``useFlickity`` hook),
 * so the carousel behavior is preserved exactly. The legacy
 * ``<section role="region" aria-label=...>`` wrapper (formerly in
 * ``slide_show.html``) moves into this component per the Phase-1 "wrapper in
 * React" rule.
 */
export const FlagshipSlideShowBlock = (
    props: Immutable<{ value: SlideShowBlockValue }>,
): React.JSX.Element => {
    return (
        <section
            role="region"
            aria-label={t`Tempur-Pedic Experience Slideshow`}
        >
            <FlagshipSlideshow images={props.value.serialized_slides} />
        </section>
    );
};
